export const AdminRole = {
  administrator: "administrator",
  manager: "manager",
  viewer: "viewer",
};

export const Permission = {
  view: "view",
  edit: "edit",
  delete: "delete",
  bulk: "bulk",
  import: "import",
  export: "export",
  restore: "restore",
  query: "query",
  analyzer: "analyzer",
  fields: "fields",
  audit: "audit",
  monitor: "monitor",
  search: "search",
};

const MATRIX = {
  [AdminRole.administrator]: Object.values(Permission),
  [AdminRole.manager]: [
    Permission.view,
    Permission.edit,
    Permission.export,
    Permission.query,
    Permission.analyzer,
    Permission.monitor,
    Permission.search,
  ],
  [AdminRole.viewer]: [Permission.view, Permission.export, Permission.monitor, Permission.search],
};

export function resolveAdminRole(user) {
  const r = String(user?.role || "viewer").toLowerCase().replace(/\s+/g, "_");
  if (r === "admin" || r === "administrator" || r === "super_admin" || r === "superadmin") {
    return AdminRole.administrator;
  }
  if (r === "manager") return AdminRole.manager;
  return AdminRole.viewer;
}

export function canAccessConsole(user) {
  const role = resolveAdminRole(user);
  return role !== AdminRole.viewer || user?.permissions?.includes?.("admin");
}

export function hasPermission(user, permission) {
  const role = resolveAdminRole(user);
  if (role === AdminRole.administrator) return true;
  return MATRIX[role]?.includes(permission) ?? false;
}

export function roleLabel(role) {
  if (role === AdminRole.administrator) return "Administrator";
  if (role === AdminRole.manager) return "Manager";
  return "Viewer";
}
